import { createContext, useContext, useState, useRef } from 'react';
import { MENU_TRANSITION_ANIMATION_MS } from './PublicCatalogMobileCategoriesMenu';
const defaultMenuContext = {
  isMenuOpen: false,
  isSubMenuOpen: false,
  isMenuModalRendered: false,
  activeSubMenu: 'MARKETING',
  openMenuModal: () => {},
  closeMenuModal: () => {},
  openSubMenu: () => {},
  closeSubMenu: () => {},
  menuModalRef: {
    current: null
  }
};
export const MenuStateContext = /*#__PURE__*/createContext(defaultMenuContext);
export const useGetMenuStateContextWithValue = initialSubMenuName => {
  const [isMenuOpen, setIsMenuOpen] = useState(defaultMenuContext.isMenuOpen);
  // used to allow transition animation, isMenuModalRendered controls when the component is rendered, isMenuOpen controls css translation
  const [isMenuModalRendered, setIsMenuModalRendered] = useState(defaultMenuContext.isMenuModalRendered);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(initialSubMenuName ? true : defaultMenuContext.isSubMenuOpen);
  const [activeSubMenu, setActiveSubMenu] = useState(initialSubMenuName || defaultMenuContext.activeSubMenu);
  const menuModalRef = useRef(null);
  const openSubMenu = subMenu => {
    setActiveSubMenu(subMenu);
    setIsSubMenuOpen(true);
    // reset the scroll postion of the menu when opening sub menu
    if (menuModalRef.current) menuModalRef.current.scrollTop = 0;
  };
  const closeSubMenu = () => {
    setIsSubMenuOpen(false);
    // reset the scroll postion of the menu when closing sub menu
    if (menuModalRef.current) menuModalRef.current.scrollTop = 0;
  };
  const openMenuModal = () => {
    const isSubMenuDropdown = !!initialSubMenuName;
    if (isSubMenuDropdown) setIsSubMenuOpen(true);
    setIsMenuModalRendered(true);
    setTimeout(() => setIsMenuOpen(true), 0);
  };
  const closeMenuModal = () => {
    setIsMenuOpen(false);
    setIsSubMenuOpen(false);
    setTimeout(() => setIsMenuModalRendered(false), MENU_TRANSITION_ANIMATION_MS);
  };
  const contextValue = {
    isMenuOpen,
    isSubMenuOpen,
    isMenuModalRendered,
    activeSubMenu,
    openMenuModal,
    closeMenuModal,
    openSubMenu,
    closeSubMenu,
    menuModalRef
  };
  return [MenuStateContext, contextValue];
};
export const useMenuStateContext = () => useContext(MenuStateContext);